import { useEffect, useState, type ReactNode } from 'react';
import { QueryClientProvider, useQueryClient } from '@tanstack/react-query';

import { createTenantQueryClient } from '@/lib/query/client';
import { readQueryScope } from '@/lib/query/scope';
import { subscribeSessions } from '@/lib/session';

export function TenantQueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(createTenantQueryClient);

  return (
    <QueryClientProvider client={client}>
      <QueryIdentity>{children}</QueryIdentity>
    </QueryClientProvider>
  );
}

function QueryIdentity({ children }: { children: ReactNode }) {
  const client = useQueryClient();
  const [identity, setIdentity] = useState(identityKey);

  useEffect(() => {
    return subscribeSessions(() => {
      const next = identityKey();
      setIdentity((current) => {
        if (current !== next) client.clear();
        return next;
      });
    });
  }, [client]);

  return <div data-query-identity={identity} className="contents">{children}</div>;
}

function identityKey(): string {
  const scope = readQueryScope();
  return `${scope.tenantHost}|${scope.actorId}`;
}
